/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { translate } from '../../../../common/translation/translate';
import { TwitterIcon } from '../../../common/icons/socialMediaIcons/twitterIcon';
import { FacebookIcon } from '../../../common/icons/socialMediaIcons/facebookIcon';
import { YouTubeIcon } from '../../../common/icons/socialMediaIcons/youTubeIcon';
import { InstagramIcon } from '../../../common/icons/socialMediaIcons/instagramIcon';
import { PinterestIcon } from '../../../common/icons/socialMediaIcons/pinterestIcon';

export const FooterSocialSection = memo(() => {
    return (
        <SocialWrapper>
            <SocialContainer>
                <SocialLead>
                    {translate('connectWithUs')}
                </SocialLead>
                <SociaList>
                    <SocialItem
                        aria-label="Visit WeatherBug's Twitter profile" 
                        href='https://twitter.com/WeatherBug' 
                        target='_blank' 
                        rel='noopener'>
                        <TwitterIcon />
                    </SocialItem>
                    <SocialItem 
                        href='https://www.youtube.com/user/WeatherBugVideo'
                        aria-label="Visit WeatherBug's YouTube channel"   
                        target='_blank' 
                        rel='noopener'>
                        <YouTubeIcon />
                    </SocialItem>
                    <SocialItem 
                        href='https://www.facebook.com/WeatherBug/' 
                        target='_blank'
                        aria-label="Visit WeatherBug's Facebook page" 
                        rel='noopener'>
                        <FacebookIcon />
                    </SocialItem>
                    <SocialItem 
                        href='https://www.instagram.com/weatherbug/'  
                        target='_blank'
                        aria-label="Visit WeatherBug's Instagram profile"  
                        rel='noopener'>
                        <InstagramIcon />
                    </SocialItem>
                    <SocialItem 
                        href='https://www.pinterest.com/weatherbug'  
                        target='_blank'
                        aria-label="Visit WeatherBug's Pinterest profile"  
                        rel='noopener'>
                        <PinterestIcon />
                    </SocialItem>
                </SociaList>
            </SocialContainer>
        </SocialWrapper>
    );
});

FooterSocialSection.displayName = 'FooterSocialSection';

const SocialWrapper = styled.div`
    display: flex;
    padding: 36px 0;
    width: 100%;
    background-color: #2f6f8c;
    @media ${mediumMediaQuery} {
        padding: 48px 0;
    }
`;

const SocialContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 0;
    white-space: nowrap;
    align-items: center;
    justify-content: space-between;
`;

const SocialLead = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;
    font-size: 22px;
    font-weight: 400;
    color: white;
    @media ${mediumMediaQuery} {
        margin-bottom: 0;
    }
`;

const SociaList = styled.div`
    display: flex;
    flex-direction: row;
    width: 500px;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    margin-top: 9px;
    padding-left: 0;
    @media ${smallMediaQuery} {
        width: 320px;
        justify-content: space-around;
    }
`;

const SocialItem = styled.a`
    display: flex;
    text-decoration: none;
    width: auto;
    height: auto;
`;
